/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate, useParams, Link } from 'react-router-dom'

import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Collapse from '@mui/material/Collapse'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
// import { Link } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import VisibilityIcon from '@mui/icons-material/Visibility'
import InfoIcon from '@mui/icons-material/Info'
import SendIcon from '@mui/icons-material/Send'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import { ExpandMore } from '../../../helpers/cardHelpers'
import { getPayload, getTokenFromLocalStorage, userIsAuthenticated } from '../../../helpers/storage'
import { positionChangeHeightSm, positionChangeWidthSm, swipelyticsPink, swipelyticsTurquoise } from '../../../helpers/variableDefaults'
import useWindowDimensions from '../../../helpers/windowDimensions'
import { standardButton } from '../../../helpers/buttons'
import { dummyBox, capitalizeFirstLetter, oneDayAgo, oneMinuteAgo, dateToNumber } from '../../../helpers/globalHelpers'
import { returnVideoThumbnailFromLiveURL, returnDurationFromLiveURL } from '../../../helpers/imageHandling'
import { profileCardImage } from '../../../helpers/commonJSX'
import { standardSpinner } from '../../../helpers/spinners'
import { saveAndCancelButtonsJSX } from '../../../helpers/commonJSX'
import { standardErrorContainer } from '../../../helpers/errors'
import { handleSetVideoThumbnailDatingProfile, totalScore, totalGrade, totalGradeColor } from '../../../helpers/commonMethods'

import profPicDefault from '../../../assets/seed-profpic-default-2.jpg'

const FeedbackProfileItem = (props) => {
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // Destructure Props
  const { profileReview, profileReviewIndex, user, setUser, fromComponent, openFeedbackInfo, setOpenFeedbackInfo, setReviewerProfileInfo, setSelectedProfileReview, isDemo, loadingDeleteProfileReview, setLoadingDeleteProfileReview, datingProfile, setDatingProfile, deletedProfileReviewIndex, setDeletedProfileReviewIndex } = props
  // console.log('profileReview ->', profileReview)

  // Payload
  const payload = getPayload()

  // Navigate
  const navigate = useNavigate()

  // Params
  // const { userId } = useParams()

  // URL Path
  const urlPath = window.location.pathname

  // Video Handling
  const [videoDuration, setVideoDuration] = useState(-1)
  const [videoThumbnail, setVideoThumbnail] = useState('')
  
  // Delete Profile Confirmation
  const [showDeleteProfileReviewConfirmation, setShowDeleteProfileReviewConfirmation] = useState(false)
  const [deleteProfileReviewError, setDeleteProfileReviewError] = useState(false)

  useEffect(() => {
    // console.log('SelectMediaInstanceCard useEffect runs')
    // console.log('mediaItem ->', mediaItem)
    const getData = async () => {
      await handleSetVideoThumbnailDatingProfile(profileReview, 0, setVideoThumbnail, setVideoDuration)
    }

    if ('media' in profileReview && profileReview.media.length > 0 && profileReview.media[0].mediaType === 'video') {
      getData()
    }

  }, [])

  useEffect(() => {
    // console.log('useEffect Runs')
    // console.log('videoThumbnail ->', videoThumbnail)

  }, [videoThumbnail, showDeleteProfileReviewConfirmation])

  // Edit Pressed button handler for people with 'write' or 'admin' privileges
  const handleViewPressed = (e) => {
    e.preventDefault()
    console.log('handleViewPressed runs')

    if (!isDemo) {
      navigate(`/dating-profile/${profileReview.datingProfileId}/${profileReview.userId}/client/${profileReview._id}/view-feedback`)
    } else {
      navigate(`/demo/${user.bio.vitalInfo.firstName.toLowerCase()}/${profileReview.type}/${profileReview.reviewerProfile.bio.vitalInfo.firstName.toLowerCase().replace(/ /g,'')}/view-feedback`)
    }
  }

  const handleInfoPressed = (e) => {
    e.preventDefault()
    console.log('handleInfoPressed runs')

    // Open Info Modal
    if (
      'reviewerProfile' in profileReview 
      && profileReview.reviewerProfile !== null 
      && Object.keys(profileReview.reviewerProfile).length > 0
    ) {
      setSelectedProfileReview(profileReview)
      setReviewerProfileInfo(profileReview.reviewerProfile)
      setOpenFeedbackInfo(true)
    } else {
      setSelectedProfileReview(profileReview)
      setOpenFeedbackInfo(true)
    }
    
  }

  const handleTrashPressed = (e) => {
    e.preventDefault()
    // console.log('handleEditPressed runs')

    if (!isDemo) {
      console.log('profile delete confirmation should appear')
      setDeletedProfileReviewIndex(profileReviewIndex)
      setShowDeleteProfileReviewConfirmation(true)
    } else {
      console.log('No deleting demo profiles')
    }

    // navigate(`/estate/${estateId}/${item._id}/edit`)
  }

  const deleteIconDisabled = (viewInfoOrDelete) => {
    return (
      viewInfoOrDelete === 'delete'
      &&
      (
        isDemo 
        || 
        !(
          (
            !profileReview.reviewSubmitted 
            && !profileReview.isFriendReview 
            && !profileReview.isAIReview
          )
          || profileReview.isFriendReview
          || 
          (
            profileReview.isAIReview 
            && 
            (
              profileReview.reviewSubmitted 
              // || (dateToNumber(profileReview.createdAt) < Date.now())
              || (dateToNumber(profileReview.createdAt) < oneDayAgo())
            )
          )
        )
      )
    )
  }

  // View Profile Icon Button JSX
  const viewInfoOrDeleteItemIconJSX = (viewInfoOrDelete = 'view') => {
    // console.log('deleteIconDisabled ->', deleteIconDisabled(viewInfoOrDelete))
    return (
      <Box
        sx={{
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-end',
        }}
      >
        <IconButton
          onClick={viewInfoOrDelete === 'delete' ? handleTrashPressed : profileReview.reviewSubmitted ? handleViewPressed : handleInfoPressed} 
          disabled={openFeedbackInfo || deleteIconDisabled(viewInfoOrDelete)}
          sx={{ 
            width: '30px', height: '30px', 
            mb: 1, mt: 1, mr: width < positionChangeWidthSm ? 1 : 2, ml: 2,bottom: 0, left: 0, 
            border: 0, borderColor: 'white', boxShadow: 0, 
          }} 
        >
          {viewInfoOrDelete === 'delete' ?
            <DeleteIcon 
              fontSize="small" 
              color={deleteIconDisabled(viewInfoOrDelete) || openFeedbackInfo ? 'disabled' : 'secondary'}
              disabled={deleteIconDisabled(viewInfoOrDelete)}
              sx={{ 

              }} 
            />
            :
            profileReview.reviewSubmitted ?
              <VisibilityIcon 
                fontSize="small" 
                color={openFeedbackInfo ? '' : 'primary'}
                sx={{ 

                }} 
              />
              :
              <InfoIcon 
                fontSize="small" 
                color={openFeedbackInfo ? '' : 'primary'}
                sx={{ 

                }} 
              />
          }
        </IconButton>
      </Box>
    )
  }

  const cancelDeleteProfileReview = () => {
    console.log('cancelDeleteProfileReview pressed')
    setDeletedProfileReviewIndex(-1)
    setShowDeleteProfileReviewConfirmation(false)
  }


  const handleDeleteProfileReview = async (e) => {
    e.preventDefault()
    // console.log('handleDeleteProfileReview runs')

    if (!isDemo) {
      console.log('profile should delete')
      try {
        setLoadingDeleteProfileReview(true)
        setDeleteProfileReviewError(false)

        await axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/profile-reviews/${profileReview._id}`, {
          headers: {
            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
          },
        })

        const newProfileReviews = datingProfile.profileReviews.filter((profileReviewToFilter, profileReviewToFilterIndex) => profileReviewToFilter._id !== profileReview._id)
        setDatingProfile({ ...datingProfile, profileReviews: [ ...newProfileReviews ] })

        setShowDeleteProfileReviewConfirmation(false)
        setDeletedProfileReviewIndex(-1)
        setLoadingDeleteProfileReview(false)
      } catch (error) {
        console.log('delete profile review error ->', error)

        setDeleteProfileReviewError(true)
        setShowDeleteProfileReviewConfirmation(false)
        setDeletedProfileReviewIndex(-1)
        setLoadingDeleteProfileReview(false)
      }

    } else {
      console.log('No deleting demo profile reviews')
    }

    // navigate(`/estate/${estateId}/${item._id}/edit`)
  }

  return (
    <Card 
      align="left" 
      sx={{ 
        mt: 2,
        backgroundColor: 'whitesmoke',
        // width: width < positionChangeWidthSm ? '80%' : '95%', boxShadow: 3, borderRadius: 3,
        width: '100%', 
        boxShadow: 3, borderRadius: 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
      }}
    >
      {/* Displays as a column on mobile and row on desktop */}
      <Box
        sx={{
          width: '100%',
          display: 'flex', flexDirection: width < positionChangeWidthSm ? 'column' : 'row', justifyContent: width < positionChangeWidthSm ? 'flex-start' : 'space-between', alignItems: 'center',
        }}
      >
        {loadingDeleteProfileReview && deletedProfileReviewIndex === profileReviewIndex ?
          <Box sx={{ 
            width: '100%',
            minHeight: width < positionChangeWidthSm ? '400px' : '220px',
            // height: width < positionChangeWidthSm ? '400px' : '220px',
            // minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
            // minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight})`,
            mt: 0, mb: 0,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
          }}>
            {standardSpinner()}
          </Box>
          :
          showDeleteProfileReviewConfirmation ?
            <Box
              sx={{
                width: '100%',
                minHeight: width < positionChangeWidthSm ? '400px' : '190px',
                // height: width < positionChangeWidthSm ? '400px' : '220px',
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  mt: 2,
                  width: '90%',
                  maxWidth: '300px',
                  fontWeight: 'bold',
                }}
              >
                {/* {'priceOfReview' in profileReview && profileReview.priceOfReview > 0 ? `You will not be refunded for your purchase. ` : ``}Are you sure you would like to delete this profile review? */}
                Are you sure you would like to delete this profile review?
              </Typography>

              {saveAndCancelButtonsJSX(
                false,
                loadingDeleteProfileReview,
                cancelDeleteProfileReview,
                handleDeleteProfileReview,
                1,
                1,
                1,
                'primary',
                'error'
              )}

              {deleteProfileReviewError &&
                standardErrorContainer(
                  `There was an error deleting your profile. Check your Internet connection and try again`,
                  0,
                  1
                )
              }
            
            </Box>
            :
            <Box
              sx={{
                // height: width < positionChangeWidthSm ? '300px' : '200px',
                width: '100%',
                display: 'flex', flexDirection: width < positionChangeWidthSm ? 'column' : 'row', justifyContent: width < positionChangeWidthSm ? 'center' : 'flex-start', alignItems: width < positionChangeWidthSm ? 'center' : 'center',
              }}
            >
              {/* If Mobile, edit button appears at top right corner of column */}
              {width < positionChangeWidthSm && 
                <Box 
                  sx={{
                    mb: -3,
                    width: '100%',
                    display: 'flex', flexDirection: 'row', justifyContent: 'flex-end',
                  }}
                >
                  {viewInfoOrDeleteItemIconJSX(profileReview.reviewSubmitted ? 'view' : 'info')}
                </Box>
              }

              {/* {console.log('media url ->', profileReview.media)} */}
              {/* Image */}
              <Box
                onClick={profileReview.reviewSubmitted ? handleViewPressed : handleInfoPressed} 
                sx={{
                  cursor: 'pointer',
                }}
              >
                {profileCardImage(profileReview, videoThumbnail, profPicDefault, width, 'feedbackProfile')}
              </Box>
              

              {/* Type and Vibe, Completed, Feedback Drafts */}
              <Box
                onClick={profileReview.reviewSubmitted ? handleViewPressed : handleInfoPressed} 
                sx={{
                  // backgroundColor: 'yellow',
                  ml: width < positionChangeWidthSm ? 0 : 1,
                  mb: width < positionChangeWidthSm ? 2 : 0,
                  width: '100%',
                  cursor: 'pointer',
                  display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center',
                }}
              >

                {/* Reviewer Name */}
                {'reviewerFirstName' in profileReview &&
                  <Typography
                    textAlign={width < positionChangeWidthSm ? 'center' : 'left'}
                    sx={{
                      mb: width < positionChangeWidthSm ? 0 : 0,
                      width: '95%',
                      fontSize: width < positionChangeWidthSm ? '16px' : '18px',
                    }}
                  >
                    Reviewer: <span style={{ fontWeight: 'bold' }}>{capitalizeFirstLetter(profileReview.reviewerFirstName)}</span>
                  </Typography>
                }
                

                {/* Type */}
                <Typography
                  textAlign={width < positionChangeWidthSm ? 'center' : 'left'}
                  sx={{
                    width: '95%',
                    fontSize: width < positionChangeWidthSm ? '16px' : '18px',
                  }}
                >
                  Review Type: <span style={{ fontWeight: 'bold' }}>{profileReview.isAIReview ? `AI` : profileReview.isFriendReview ? `Friend` : `Expert`}</span>
                </Typography>

                {/* Completed */}
                {!profileReview.reviewSubmitted &&
                  <Typography
                    textAlign={width < positionChangeWidthSm ? 'center' : 'left'}
                    sx={{
                      mb: width < positionChangeWidthSm ? 0 : 0,
                      width: '95%',
                      fontSize: width < positionChangeWidthSm ? '16px' : '18px',
                    }}
                  >
                    Review Completed: <span style={{ fontWeight: 'bold', color: profileReview.reviewSubmitted ? 'green' : 'red' }}>{profileReview.reviewSubmitted ? 'Yes' : 'No'}</span>
                  </Typography>
                }

                {/* Score */}
                {profileReview.reviewSubmitted 
                  && 'mediaFeedback' in profileReview 
                  && profileReview.mediaFeedback.length > 0 
                  &&
                  <Typography
                    textAlign={width < positionChangeWidthSm ? 'center' : 'left'}
                    sx={{
                      mb: width < positionChangeWidthSm ? 0 : 0,
                      width: '95%',
                      fontSize: width < positionChangeWidthSm ? '16px' : '18px',
                    }}
                  >
                    Score: <span style={{ fontWeight: 'bold', color: 'black' }}>{totalScore(profileReview.type, profileReview.mediaFeedback, profileReview.bioFeedback)}</span>
                  </Typography>
                }

                {/* Grade */}
                {profileReview.reviewSubmitted
                  && 'mediaFeedback' in profileReview 
                  && profileReview.mediaFeedback.length > 0 
                  &&
                  <Typography
                    textAlign={width < positionChangeWidthSm ? 'center' : 'left'}
                    sx={{
                      mb: width < positionChangeWidthSm ? 0 : 0,
                      width: '95%',
                      fontSize: width < positionChangeWidthSm ? '16px' : '18px',
                    }}
                  >
                    Grade: <span style={{ fontWeight: 'bold', color: totalGradeColor('reviewCard', totalGrade(totalScore(profileReview.type, profileReview.mediaFeedback, profileReview.bioFeedback))) }}>{totalGrade(totalScore(profileReview.type, profileReview.mediaFeedback, profileReview.bioFeedback))}</span>
                  </Typography>
                }

              </Box>

              {/* View, Info, Delete Icon */}
              {width >= positionChangeWidthSm &&
                <Box
                  sx={{
                    height: width < positionChangeWidthSm ? '' : '160px',
                    display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
                  }}
                >
                  {viewInfoOrDeleteItemIconJSX(profileReview.reviewSubmitted ? 'view' : 'info')}


                  {/* Delete Profile Button */}
                  {
                    viewInfoOrDeleteItemIconJSX('delete')
                  }
                </Box>
              }

              {/* Delete button for mobile */}
              {width < positionChangeWidthSm 
                &&
                <Box 
                  sx={{
                    mt: -1,
                    width: '100%',
                    display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  {viewInfoOrDeleteItemIconJSX('delete')}
                </Box>
              }

            </Box>
        }
      </Box>
      
    </Card>
  )
}

export default FeedbackProfileItem